import clsx from 'clsx';
import { Fragment, type CSSProperties } from 'react';
import { getSafeHtmlTextLines } from '@publishing/helpers/format';
import { GTM_EVENT } from '@/shared/constants/gtm';
import { gtmClick } from '@/shared/utils/gtm';
import type { BlogArticle } from './_types';
import styles from './BlogLatest.module.scss';

interface BlogLatestProps {
  articles: BlogArticle[];
  compact?: boolean;
  showKeywords?: boolean;
  className?: string;
}

function renderSafeTitle(title: string) {
  const lines = getSafeHtmlTextLines(title);

  return lines.map((line, index) => (
    <Fragment key={`${line}-${index}`}>
      {line}
      {index < lines.length - 1 && <br />}
    </Fragment>
  ));
}

export default function BlogLatest({ articles, compact = false, showKeywords = false, className }: BlogLatestProps) {
  if (!articles.length) return null;

  return (
    <>
      {articles.map((article, i) => (
        <a
          key={`${article.href}-${i}`}
          href={article.href}
          className={clsx(styles.post_card, className)}
          style={article.color ? { '--post-category-color': `var(--color-${article.color.toLowerCase()}-600)` } as CSSProperties : undefined}
          // btnname 은 글 제목 — 원문에 <br> 등 마크업이 섞여 있어 화면과 동일한 평문으로 맞춘다.
          {...gtmClick(GTM_EVENT.BTN, getSafeHtmlTextLines(article.title).join(' '), article.href)}
        >
          {article.image ? (
            <img src={article.image} alt={article.title} className={styles.post_image} />
          ) : (
            <div className={styles.post_image_placeholder} />
          )}
          <div className={styles.post_body}>
            {article.category && (
              <span className={styles.post_category}>{article.category}</span>
            )}
            <p className={clsx(styles.post_title, compact && styles.post_title_compact)}>
              {renderSafeTitle(article.title)}
            </p>
            {showKeywords && article.hashtag && (
              <ul className={styles.keywords}>
                {article.hashtag.split(',').map((tag) => (
                  <li key={tag} className={styles.keyword}>{tag.trim()}</li>
                ))}
              </ul>
            )}
          </div>
        </a>
      ))}
    </>
  );
}
